import { createContext, useReducer, useContext, useEffect } from "react";

const initialState = {
  cv: sessionStorage.getItem("cv") || "",  // Récupère le CV de la session si disponible
  cvName: sessionStorage.getItem("cvName") || "",
  // isCvSaved: se:ssionStorage.getItem("isCvSaved") === "true", // Convertit la valeur string en booléen
};

const cvReducer = (state, action) => {
  switch (action.type) {
    case "SET_CV":
      // if (state.isCvSaved) {
      sessionStorage.setItem("cv", action.payload.content);
      sessionStorage.setItem("cvName", action.payload.name);
      // sessionStorage.setItem("isCvSaved", "true");
      // }
      return {
        ...state,
        cv: action.payload.content,  // ✅ Met à jour l'UI immédiatement
        cvName: action.payload.name,
      };

    case "SAVE_CV":
      // sessionStorage.setItem("isCvSaved", "true");
      return {
        ...state,
        // isCvSaved: true,
      };

    case "RESET_CV":
      sessionStorage.removeItem("cv");
      sessionStorage.removeItem("cvName");
      sessionStorage.removeItem("isCvSaved");
      return {
        ...state,
        cv: "",
        cvName: "",
        isCvSaved: false,
      };

    default:
      return state;
  }
};


const CvContext = createContext();

// 4️⃣ Provider avec récupération de sessionStorage
export const CvProvider = ({ children }) => {
  const [state, dispatch] = useReducer(cvReducer, initialState);

  useEffect(() => {
    // Restaurer les données au montage (si ce n'est pas encore fait)
    const storedCV = sessionStorage.getItem("cv");
    const storedCVName = sessionStorage.getItem("cvName");
    const storedIsCvSaved = sessionStorage.getItem("isCvSaved") === "true";

    if (storedCV && storedCVName) {
      dispatch({
        type: "SET_CV",
        payload: { content: storedCV, name: storedCVName },
      });
    }

    if (storedIsCvSaved) {
      dispatch({ type: "SAVE_CV" });
    }
  }, []);

  return (
    <CvContext.Provider value={{ state, dispatch }}>
      {children}
    </CvContext.Provider>
  );
};

export const useCv = () => useContext(CvContext);
